var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "occupation-private" }, [
    _c("div", { staticClass: "tab-wrapper w-100" }, [
      _c("div", { staticClass: "wrapper-nav" }, [
        _vm.numActiveTabs
          ? _c(
              "ul",
              {
                staticClass: "nav nav-pills nav-fill",
                attrs: { role: "tablist" },
              },
              _vm._l(_vm.activeTabs, function (tab, index) {
                return _c(
                  "li",
                  { key: `tab-${index}`, staticClass: "nav-item" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "nav-link nav-label",
                        class: { active: _vm.selectedTab.id == tab.id },
                        attrs: {
                          "data-toggle": "tab",
                          role: "tab",
                          id: `occupation-item-${tab.id}-tab`,
                          href: "javascript:void(0);",
                          "aria-controls": `occupation-item-${tab.id}`,
                          "aria-selected": _vm.selectedTab.id == tab.id,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.activeTab = tab
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "nav-label-content" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t(tab.name)) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-content" },
        _vm._l(_vm.activeTabs, function (tab) {
          return _c(
            "div",
            {
              key: `tab-pane-${tab.id}`,
              staticClass: "tab-pane fade",
              class: { "show active": _vm.selectedTab.id == tab.id },
              attrs: {
                role: "tabpanel",
                id: `occupation-item-${tab.id}`,
                "aria-labelledby": `occupation-item-${tab.id}-tab`,
              },
            },
            [
              _c(tab.component, {
                tag: "component",
                attrs: {
                  panelCfg: _vm.panelCfg,
                  parentId: _vm.parentId,
                  moduleCode: _vm.moduleCode,
                  additional: _vm.additional,
                  baseTranslateID: tab.baseTranslateID,
                },
                model: {
                  value: tab.model,
                  callback: function ($$v) {
                    _vm.$set(tab, "model", $$v)
                  },
                  expression: "tab.model",
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }